<template>
  <div>
    <mt-header
      fixed
      :title="$route.meta.title.toLocaleUpperCase()"
    >
      <div
        slot="left"
        class="nav-left"
        v-if="navState"
        @click="backLink"
      >
        <img
          style="width: 18px; height: 18px;"
          :src="navIcon"
          alt=""
        >
        <span style="padding-left: 10px">NAV</span>
      </div>
      <div
        slot="left"
        class="nav-left"
        v-if="!navState"
        @click="backLink"
      >
        <img
          style="width: 18px; height: 18px;"
          :src="backIcon"
          alt=""
        >
        <span style="padding-left: 10px">BACK</span>
      </div>
      <div slot="right">
        <img
          @click="popupVisible = true"
          width="20"
          height="20"
          :src="langIcon"
        >
        <img
          width="20"
          height="20"
          style="margin-left: 10px;"
          :src="logoutIcon"
          alt=""
          @click="logout"
        >
      </div>
    </mt-header>
    <transition
      name="fade"
      mode="out-in"
    >
      <!-- <router-view :key="key"></router-view> -->
      <keep-alive v-if="$route.meta.keepLive">
        <router-view style="padding-top: 40px"></router-view>
      </keep-alive>
      <router-view
        v-else
        style="padding-top: 40px"
      ></router-view>
    </transition>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
    >
      <ul class="lang-list">
        <li
          :class="{'current': item.key== language}"
          v-for="item in langList"
          :key="item.key"
          @click="selectLang(item.key)"
        >{{item.value}}</li>
      </ul>
    </mt-popup>
  </div>
</template>
<script>
export default {
  name: 'wapIndex',
  data() {
    return {
      logoutIcon: require('../../assets/images/log_out.svg'),
      langIcon: require('../../assets/images/lang.svg'),
      navIcon: require('../../assets/images/nav.svg'),
      backIcon: require('../../assets/images/back.svg'),
      popupVisible: false,
      langList: [
        { key: 'en', value: 'ENGLISH' },
        { key: 'ja', value: '日本語' },
        { key: 'zh', value: '中文' },
      ],
    }
  },
  methods: {
    backLink() {
      if (
        this.$route.name == 'orderList' ||
        this.$route.name == 'productList' ||
        this.$route.name == 'userAdd'
      ) {
        this.$router.push('/wap/orderNav')
      } else if (this.$route.name == 'orderDetail') {
        this.$router.push('/wap/orderList')
      } else if (this.$route.name == 'orderNav') {
        this.$router.back(-1)
      } else if (this.$route.name == 'productAdd') {
        this.$router.push('/wap/orderNav')
      }
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    selectLang(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('SetLanguage', lang)
      window.location.reload()
    },
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    navState() {
      if (
        this.$route.name == 'productList' ||
        this.$route.name == 'orderList' ||
        this.$route.name == 'userAdd' 
      ) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mint-header {
  background-color: #465dd2;
}
.mint-navbar .mint-tab-item.is-selected {
  border-bottom: 2px solid #465dd2;
  color: #465dd2;
}
.mint-popup-bottom {
  width: 100%;
}
.lang-list {
  width: 100%;
  line-height: 32px;
  .current {
    color: #465dd2;
    font-weight: 600;
  }
}
.nav-left {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: left;
}
</style>




// WEBPACK FOOTER //
// src/views/wap/index.vue